import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataCounts, createDataCount, updateDataCount, deleteDataCount } from '../../Reducer/dataCountSlice';
import AddDataCount from './AddDataCount';
import EditDataCount from './EditDataCount';
import DataCountList from './DataCountList';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './datacount.css';

const DataCount = () => {
  const dispatch = useDispatch();
  const { dataCounts, status } = useSelector((state) => state.dataCount);
  const [editingId, setEditingId] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);

  useEffect(() => {
    if (status === 'idle') {
      dispatch(fetchDataCounts());
    }
  }, [dispatch, status]);

  const handleAddDataCount = async (data) => {
    try {
      dispatch(createDataCount(data));
      toast.success("Data count added successfully!");
      setShowAddForm(false);
      dispatch(fetchDataCounts());
    } catch (error) {
      toast.error("Failed to add data count");
    }
  };

  const handleUpdateDataCount = async (id, updatedData) => {
    try {
      dispatch(updateDataCount({ id, updatedData }));
      toast.success("Data count updated successfully!");
      setEditingId(null);
      dispatch(fetchDataCounts());
    } catch (error) {
      toast.error("Failed to update data count");
    }
  };

  const handleDeleteDataCount = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await dispatch(deleteDataCount(id));
        toast.success("Data count deleted successfully!");
        dispatch(fetchDataCounts());
      } catch (error) {
        toast.error("Failed to delete data count");
      }
    }
  };

  const handleEditClick = (id) => {
    setEditingId(id);
  };

  const handleClose = () => {
    setEditingId(null);
    setShowAddForm(false);
  };

  return (
    <div className="data-count-container">
      <h1>Data Count</h1>

      <button className="add-btn" onClick={() => setShowAddForm(true)}>
        <AddIcon className="add-icon" /> Add Data Count
      </button>

      {/* Left Side Drawer for Add Form */}
      <Drawer anchor="right" open={showAddForm} onClose={handleClose}>
        <div style={{ width: 400, padding: 20 }}>
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
          <h2 style={{ marginTop: 0 }}>Add Data Count</h2>
          <AddDataCount onClose={handleClose} onSubmit={handleAddDataCount} />
        </div>
      </Drawer>

      {/* Conditional rendering for Edit component */}
      {editingId && (
        <EditDataCount 
          id={editingId} 
          onClose={handleClose} 
          onSubmit={handleUpdateDataCount} 
        />
      )}

      <DataCountList 
        dataCounts={dataCounts} 
        onEdit={handleEditClick} 
        onDelete={handleDeleteDataCount} 
      />
    </div>
  );
};

export default DataCount;
